export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
export const BACKEND_SERVER_URL = process.env.REACT_APP_API_URL;
export const BACKEND_SERVER_URL_USER_EARNINGS =
  process.env.REACT_APP_API_URL_USER_EARNINGS;
